import { Action } from 'redux';
import { OrderedMap } from 'immutable';

import { 
    GET_REQUESTS_REQUEST,
    GET_REQUESTS_RESPONSE,
    GET_REQUESTS_ERROR,

    GET_REQUESTS_TYPES_REQUEST,
    GET_REQUESTS_TYPES_RESPONSE,

    SET_REQUEST_TYPE,

    LIKE_RESPONSE,

    DISLIKE_RESPONSE,
} from '../../actions/Requests/requests';

import { Request, RequestType } from '../../models/Requests/Request';

export interface RequestsState {
    requestType: string;

    requests: OrderedMap<number, Request>;
    loadingRequests: boolean;
    errorRequests: any;

    requestsTypes: OrderedMap<string, RequestType>;

    page: number;
    per: number;
    nextPage: number | null;
}

const initialState: RequestsState = {
    requestType: 'all',

    requests: OrderedMap<number, Request>(),
    loadingRequests: false,
    errorRequests: null,

    requestsTypes: OrderedMap<string, RequestType>(),

    page: 1,
    per: 25,
    nextPage: -1,
};

export function requestsState(state: RequestsState = initialState, action: Action) {
    switch (action.type) {
        case GET_REQUESTS_REQUEST: {
            const getMore = !!(action as any).getMore;
            return {
                ...state,
                requests: getMore ? state.requests : initialState.requests,
                loadingRequests: !getMore,
                errorRequests: initialState.errorRequests,
            };
        }
        case GET_REQUESTS_RESPONSE: {
            const pagination = (action as any).response.pagination;
            const getMore = !!(action as any).getMore;
            const result: Request[] = (action as any).response.result;
            const requests = result.reduce((prev, cur) => prev.set(cur.request_id, cur), !getMore ? initialState.requests : state.requests);
            return {
                ...state,
                loadingRequests: false,
                requests,
                page: pagination.current_page,
                nextPage: pagination.next_page,
            };
        }
        case GET_REQUESTS_ERROR: {
            return {
                ...state,
                loadingRequests: false,
                errorRequests: (action as any).error.error,
            };
        }

        case GET_REQUESTS_TYPES_REQUEST: {
            return {
                ...state,
                requestsTypes: initialState.requestsTypes,
            };
        }
        case GET_REQUESTS_TYPES_RESPONSE: {
            const result: RequestType[] = (action as any).response.result;
            const requestsTypes = result.reduce((prev, cur) => prev.set(cur.key, cur), initialState.requestsTypes);
            return {
                ...state,
                requestsTypes,
            };
        }

        case SET_REQUEST_TYPE: {
            const requestType = (action as any).requestType;
            return {
                ...state,
                requestType,
                page: initialState.page,
                nextPage: initialState.nextPage,
            };
        }

        case LIKE_RESPONSE: {
            const requestId = (action as any).response.result.request_id;
            const request = {
                ...state.requests.get(requestId),
                mark: 1,
            };
            const requests = state.requests.set(requestId, request);
            return {
                ...state,
                requests,
            };
        }
        case DISLIKE_RESPONSE: {
            const requestId = (action as any).response.result.request_id;
            const request = {
                ...state.requests.get(requestId),
                mark: 2,
            };
            const requests = state.requests.set(requestId, request);
            return {
                ...state,
                requests,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Requests/requests.ts